<template>
  <div class="flex flex-col gap-6 items-center" data-testid="templates-upselling">
    <!-- Premium Feature Badge -->
    <div
      class="h-7 pr-2 flex items-center justify-center gap-0.5 border border-transparent rounded-full text-xs font-semibold leading-4 outline-none focus-visible:ring select-none bg-zinc-100 dark:bg-zinc-900 text-orange-500"
      data-testid="premium-feature-badge"
    >
      <Icon name="upselling.starInCircle" size="base" class="fill-current" />
      <span class="whitespace-nowrap text-transparent bg-clip-text bg-gradient-to-tr from-orange-500 to-red-500">PREMIUM FEATURE</span>
    </div>

    <!-- Description Text -->
    <p class="text-sm text-zinc-600 dark:text-zinc-400 text-center" data-testid="templates-upselling-description">
      Work faster with templates! Quickly apply pre-defined settings around your content (customization, security and more!).
    </p>

    <!-- Template Previews (same layout as DefaultTemplatesList) -->
    <ul class="flex flex-col gap-3 w-full" data-testid="templates-preview-list">
      <li
        v-for="template in templates"
        :key="template.slot"
        class="flex items-center gap-4 p-5 border border-slate-300 dark:border-zinc-700 rounded-10"
        :data-testid="`template-preview-${template.slot}`"
      >
        <div class="flex flex-none justify-center items-center w-12 h-12 rounded-full text-slate-400 bg-slate-100 dark:bg-zinc-700">
          <Icon :name="template.icon" size="base" />
        </div>
        <dl class="grow dark:text-zinc-300">
          <dt class="font-bold">{{ template.title }}</dt>
          <dd class="text-sm">{{ template.description }}</dd>
        </dl>
      </li>
    </ul>

    <!-- CTA Button at bottom -->
    <div class="flex items-center justify-center">
      <Button variant="orange" @click.prevent="handleUpgrade" data-testid="templates-upselling-cta">UPGRADE TO UNLOCK</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button, Icon } from '@/storybook';
import { useViewerTrack, TrackEvents } from '@/modules/viewer/composables/useViewerTrack';

const { trackItemOwner } = useViewerTrack();

const templates = [
  {
    slot: 'sales',
    icon: 'general.presentationBoard',
    title: 'Sales intro',
    description: 'Connect with customers and close more deals with personalized intro videos.',
  },
  {
    slot: 'bug',
    icon: 'general.bug',
    title: 'Bug report',
    description: 'Make bug reporting much easier by showing exactly what you are seeing.',
  },
  {
    slot: 'support',
    icon: 'general.chatSupport',
    title: 'Support response',
    description: 'Speed up support and delight your customers through personal video responses.',
  },
  {
    slot: 'announcement',
    icon: 'general.megaphone',
    title: 'Announcement',
    description: 'Cut through the noise and make your announcement seen and heard.',
  },
];

const handleUpgrade = (e: Event) => {
  e.stopPropagation();
  e.preventDefault();

  trackItemOwner(TrackEvents.UPGRADE_CLICK).then(() => {
    window.location.assign('/account/plans');
  });
};
</script>
